import { fetchCloseRating } from '../../../services/chatbotFeedback/fetchCloseRating';
import { TThunkAction } from '../../../types/redux/thunk';

export const setCloseRating = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  await fetchCloseRating(context);
};
